/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import {pxToEm} from '@insticator/insticator-ui';


/* ++++++++++ --------------- SENTIMENT ADVANCED SETTINGS - ADVANCED CONFIGS : STYLES --------------- ++++++++++ */
export default {
   profileconfig: {
    '& .singleselectdropdown': { 
      minWidth: pxToEm(320),
      maxWidth: pxToEm(500),
      zIndex: 9999,
      marginBottom: pxToEm(24)
    },
    '& .sectiongroup': {
        marginTop: 0,
        width: '100%',
    },
    '& .sectioncard > .sectiongroup': {
      '&:first-child': {
        rowGap: pxToEm(24)
      }
    },
    '& .type-checkbox': {
        marginBottom: '8px',
        '& label': {
            fontWeight: '400 !important',
            marginBottom: '0 !important'
        }
    },
    '& .previewconfig': {
        width: pxToEm(500)
    },
    '& .genderpreview': {
        width: pxToEm(160),
        flexDirection: 'column',
        background: '#E7EAF7',
        color: '#000',
        border: '2px solid #7B88BC',
        borderRadius: pxToEm(4),
        gap: 0,
        '& span': {
          display: 'flex',
          margin: pxToEm(4),
          padding: `${pxToEm(2)} ${pxToEm(4)}`,
          borderRadius: pxToEm(4)
        },
        '& .selected': {
          background: '#000',
          color: '#FFF'
        },
        '& .caret': {
          width: pxToEm(16),
          height: pxToEm(16),
          '& path': {
            fill: '#FFF'
          }
        }
      }
 }
};
